exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".un-float-label[data-v-7d969019] label{position:static!important;padding:0!important;font-size:14px!important;transform:none!important;line-height:inherit!important}.un-float-legend[data-v-7d969019]{margin-top:1rem}.un-float-legend[data-v-7d969019] .fieldset-label{transform:translateY(-100%);line-height:inherit!important;background-color:transparent}", ""]);

// exports
